import "core-js/modules/es6.object.freeze.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.string.link.js";
import _each from "lodash/fp/each";
import _sortBy from "lodash/fp/sortBy";
import _pick from "lodash/fp/pick";
import _getOr from "lodash/fp/getOr";
import _flow from "lodash/fp/flow";
import _find from "lodash/find";
import _ary from "lodash/ary";
import _isArray from "lodash/isArray";
import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fragment getPageTaxonomyData on PostWithPageTaxonomyInterface {\n    __typename\n    pageTaxonomy\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { gql } from '@nerdwallet/apollo';
import urlParse from 'url-parse';
import { EMBEDDED_OBJECT_TYPES, POST_TYPES, POST_TYPE_LABELS, POST_STATUSES } from '../constants';
import { getEmbeddedObject, getEmbeddedObjectsByType, getNwData, stripNwSuffix } from '../utils'; // eslint-disable-next-line import/no-cycle -- directive added automatically by Shepherd migration

import { withZ, printDeprecatedTimezoneWarning } from '../utils/date';
import * as articleSelectors from './article';
import * as reviewSelectors from './review'; // eslint-disable-next-line import/no-cycle -- directive added automatically by Shepherd migration

import * as roundupSelectors from './roundup';
/**
 * Factory function. Returned function takes a `entity` and `category` and returns the first
 * defined value at `path` on the closest category up the category ancestor tree
 *
 * @param  {string} path path on category object to return
 *
 * @return {function}      Getter function
 *
 * @private
 */

var makeGetEntityFromCategoryAncestor = function makeGetEntityFromCategoryAncestor(path) {
  var getValueFromCategoryAncestor = function getValueFromCategoryAncestor(entity) {
    var category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCategoryObjectPrimary(entity);

    var value = _get(category, path);

    if (value) {
      return value;
    }

    var parentCategory = getCategoryObjectById(entity, _get(category, 'parent'));

    if (_isEmpty(parentCategory)) {
      return null;
    }

    return getValueFromCategoryAncestor(entity, parentCategory);
  };

  return getValueFromCategoryAncestor;
};
/**
 * Map a WordPress entity to a selector by post type and call that selector
 * @private
 *
 * @param   {Object | Array} args     Either the WordPress entity or an
 *                                    array of arguments to be passed to the
 *                                    selector function. The first element of
 *                                    the array must be the WordPress entity.
 * @param   {Object} mappings         Map from entity type to function.
 *
 * @return  {any}                     The value of the called mapped function.
 */


export var callSelectorByType = function callSelectorByType(args) {
  var mappings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaultFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return undefined;
  };

  if (!_isArray(args)) {
    // eslint-disable-next-line no-param-reassign -- directive added automatically by Shepherd migration
    args = [args];
  }

  var _args = args,
      _args2 = _slicedToArray(_args, 1),
      entity = _args2[0];

  var postType = getType(entity);
  var func = mappings[postType];

  if (!func) {
    return defaultFunc.apply(void 0, _toConsumableArray(args));
  }

  return func.apply(void 0, _toConsumableArray(args));
};
/**
 * Check whether a given entity is published.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {boolean}           Whether or not the entity is published.
 */

export var isPublished = function isPublished(entity) {
  return getStatus(entity) === POST_STATUSES.PUBLISHED;
};
/**
 * Get all embedded author objects.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {Array}             All embedded authors.
 */

export var getAuthors = function getAuthors(entity) {
  return getEmbeddedObjectsByType(entity, EMBEDDED_OBJECT_TYPES.AUTHOR);
};
/**
 * Get all embedded reviewer objects.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {Array}             All embedded reviewers.
 */

export var getReviewers = function getReviewers(entity) {
  return getEmbeddedObjectsByType(entity, EMBEDDED_OBJECT_TYPES.REVIEWER);
};
/**
 * Get below content block group ID.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {number}            Below content block group ID.
 */

export var getBlockGroupIdBelowContent = function getBlockGroupIdBelowContent(entity) {
  var sidebarId = null;

  if (getUseCustomBlockGroupBelowContent(entity)) {
    sidebarId = _get(getNwData(entity), 'custom_below_content.id');
  } // Grab the default category below content block group ID.


  if (!sidebarId) {
    sidebarId = getBlockGroupIdFromEntityCategory(entity, 'nw_default_below_content');
  }

  return sidebarId;
};
/**
 * Get next steps block group ID.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {number}            Next Steps block group ID.
 */

export var getBlockGroupIdNextSteps = function getBlockGroupIdNextSteps(entity) {
  var nwData = getNwData(entity);

  if (nwData.use_custom_next_steps) {
    return _get(nwData, 'custom_next_steps.id');
  }

  return getBlockGroupIdFromEntityCategory(entity, 'nw_default_next_steps');
};
/**
 * Get related links block group ID.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {number}            Related Links block group ID.
 */

export var getBlockGroupIdRelatedLinks = function getBlockGroupIdRelatedLinks(entity) {
  var nwData = getNwData(entity);

  if (nwData.use_custom_related_links) {
    return _get(nwData, 'custom_related_links.id');
  }

  return getBlockGroupIdFromEntityCategory(entity, 'nw_default_related_links');
};
/**
 * Get sidebar block group ID.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {number}            Sidebar block group ID.
 */

export var getBlockGroupIdSidebar = function getBlockGroupIdSidebar(entity) {
  var sidebarId = null;

  if (getUseCustomBlockGroupSidebar(entity)) {
    sidebarId = _get(getNwData(entity), 'custom_sidebar.id');
  } // Grab the default category sidebar block group ID.


  if (!sidebarId) {
    sidebarId = getBlockGroupIdFromEntityCategory(entity, 'nw_default_sidebar');
  }

  return sidebarId;
};
/**
 * Get block group ID for an entity's associated category hierarchy.
 *
 * @param   {Object} entity             WordPress entity.
 * @param   {string} blockGroupLocation Identifier of the block group set on the term.
 *
 * @return  {number|null}               Block group ID.
 */

var getBlockGroupIdFromEntityCategory = function getBlockGroupIdFromEntityCategory(entity, blockGroupLocation) {
  return makeGetEntityFromCategoryAncestor("".concat(blockGroupLocation, ".id"))(entity);
};
/**
 * Get associated methodology block ID.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {number}            Methodology block ID.
 */


export var getBlockIdMethodology = function getBlockIdMethodology(entity) {
  return _get(getNwData(entity), 'methodology.id');
};
/**
 * Get embedded block object by ID.
 *
 * @param   {Object} entity     WordPress entity.
 * @param   {Object} id         id of desired object within EMBEDDED_OBJECT_TYPES.BLOCK.
 *
 * @return  {Object}            Embedded block object
 */

export var getBlockObjectById = function getBlockObjectById(entity, id) {
  return getEmbeddedObject(entity, EMBEDDED_OBJECT_TYPES.BLOCK, id);
};
/**
 * Get entity canonical url.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            Canonical url.
 */

export var getCanonicalUrl = function getCanonicalUrl(entity) {
  return _get(entity, 'nw_seo.canonical') || _get(entity, 'nw_seo_canonical') || getLink(entity);
};
/**
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {Array}             List of numerical category ids.
 */

export var getCategoryIds = function getCategoryIds(entity) {
  return _get(entity, 'categories', []);
};
/**
 * Get embedded category object by ID.
 *
 * @param   {Object} entity     WordPress entity.
 * @param   {Object} id         id of desired object within EMBEDDED_OBJECT_TYPES.TERM.
 *
 * @return  {Object}            Embedded category object
 */

export var getCategoryObjectById = function getCategoryObjectById(entity, id) {
  return getEmbeddedObject(entity, EMBEDDED_OBJECT_TYPES.TERM, id);
};
/**
 * Get embedded primary category object.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {Object}            Embedded primary category object.
 */

export var getCategoryObjectPrimary = function getCategoryObjectPrimary(entity) {
  var categoryId = _get(entity, 'nw_primary_category');

  return getCategoryObjectById(entity, categoryId);
};
/**
 * Get all embedded category objects specified in entity.categories
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {Array}             List of embedded category objects
 */

export var getCategoryObjects = function getCategoryObjects(entity) {
  return getCategoryIds(entity).map(function (categoryId) {
    return getCategoryObjectById(entity, categoryId);
  }).filter(function (categoryObject) {
    return !_isEmpty(categoryObject);
  });
};
/**
 * Get flag indicating whether or not comments are enabled.
 *
 * `entity.nw_enable_comments` fallback ensures we support post types
 * that haven't yet migrated to using `entity.nw_data`
 *
 * @see https://docs.google.com/document/d/1AdKcnL6Lu0z_Qt-7a9xKQkfROcE-dWhW0_WA93IE4us/edit
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {boolean}           Comments enabled flag.
 */

export var getCommentsEnabled = function getCommentsEnabled(entity) {
  return _get(getNwData(entity), 'enable_comments') || _get(entity, 'nw_enable_comments');
};
/**
 * Get comments thread ID.
 *
 * `entity.nw_comment_thread_id` fallback ensures we support post types
 * that haven't yet migrated to using `entity.nw_data`
 *
 * @see https://docs.google.com/document/d/1AdKcnL6Lu0z_Qt-7a9xKQkfROcE-dWhW0_WA93IE4us/edit
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            Comments thread ID.
 */

export var getCommentsThreadId = function getCommentsThreadId(entity) {
  return _get(getNwData(entity), 'comment_thread_id') || _get(entity, 'nw_comment_thread_id') || getId(entity);
};
/**
 * Get date.
 *
 * _Note: Behavior with `withTimezone === false` deprecated and to be removed in 3.0_
 *
 * @param   {Object} entity     WordPress entity.
 * @param   {boolean} withTimezone     if true, returns timestamp with timezone info.
 *
 * @return  {string}            ISO-8601 timestamp (eg. '2018-11-30T08:57:06Z').
 */

export var getDate = function getDate(entity, withTimezone) {
  return withTimezone ? withZ(_get(entity, ['date_gmt'])) : (printDeprecatedTimezoneWarning('getDate'), _get(entity, 'date') || _get(entity, ['date_gmt']));
};
/**
 * Get custom last modified date.
 *
 * _Note: Behavior with `withTimezone === false` deprecated and to be removed in 3.0_
 *
 * @param   {Object} entity     WordPress entity.
 * @param   {boolean} withTimezone     if true, returns timestamp with timezone info.
 *
 * @return  {string}            ISO-8601 timestamp (eg. '2018-11-30T08:57:06Z').
 */

export var getDateCustomLastModified = function getDateCustomLastModified(entity, withTimezone) {
  return withTimezone ? withZ(_get(getNwData(entity), ['custom_last_modified_date'])) : (printDeprecatedTimezoneWarning('getDateCustomLastModified'), _get(getNwData(entity), ['custom_last_modified_date']));
};
/**
 * Get flag indicating whether to hide the date.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {boolean}           Whether or not to show the date.
 */

export var getDateHide = function getDateHide(entity) {
  return _get(getNwData(entity), ['hide_date']);
};
/**
 * Get modified date.
 *
 * _Note: Behavior with `withTimezone === false` deprecated and to be removed in 3.0_
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            ISO-8601 timestamp (eg. '2018-11-30T08:57:06Z').
 */

export var getDateModified = function getDateModified(entity, withTimezone) {
  return withTimezone ? withZ(_get(entity, ['modified_gmt'])) : (printDeprecatedTimezoneWarning('getDateModified'), _get(entity, 'modified') || _get(entity, ['modified_gmt']));
};
/**
 * Get show last modified date.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {boolean}           Whether or not to show the last modified date.
 */

export var getDateShowLastModified = function getDateShowLastModified(entity) {
  return _get(getNwData(entity), ['show_last_modified_date']);
};
/**
 * Get flag indicating if should use custom last modified date.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {boolean}           Whether or not to use the last custom modified date.
 */

export var getDateUseCustomLastModified = function getDateUseCustomLastModified(entity) {
  return _get(getNwData(entity), ['use_custom_last_modified_date']);
};
/**
 * Get entity description.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            Description.
 */

export var getDescription = function getDescription(entity) {
  return _get(entity, 'nw_seo.description') || _get(entity, 'nw_seo_description') || _get(entity, ['excerpt', 'rendered_text']);
};
/**
 * Get custom JSON-LD to augment SEO schema.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {Object}            Extra JSON-LD schema.
 */

export var getExtraJsonLd = function getExtraJsonLd(entity) {
  return _get(entity, 'nw_seo.extra_jsonld');
};
/**
 * Get entity featured image object.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {Object}            Featured image object.
 */

export var getFeaturedImageObject = function getFeaturedImageObject(entity) {
  var featuredImageId = _get(entity, 'featured_media');

  return getEmbeddedObject(entity, EMBEDDED_OBJECT_TYPES.FEATURED_MEDIA, featuredImageId);
};
/**
 * Get entity featured image alt text.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            Featured image alt text.
 */

export var getFeaturedImageAltText = function getFeaturedImageAltText(entity) {
  return _get(getFeaturedImageObject(entity), 'alt_text');
};
/**
 * Get entity featured image info, based on a specified progression of
 * fallback image sizes.
 *
 * @param   {Object} entity     WordPress entity.
 * @param   {Array} sizes       Size to fetch. Each size will be tried
 *                              progressively until one is found.
 *
 * @return  {Object}            Image info.
 */

export var getFeaturedImageInfoWithFallback = function getFeaturedImageInfoWithFallback(entity) {
  var sizes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['primary-m-uncropped'];
  var featuredImageObject = getFeaturedImageObject(entity);
  return !_isEmpty(sizes) && _get(featuredImageObject, ['media_details', 'sizes', sizes[0]], getFeaturedImageInfoWithFallback(entity, sizes.slice(1)) || null);
};
/**
 * Get the featured image's natural height.
 *
 * @param   {Object} entity     WordPress entity.
 * @param   {Array} sizes       Size to fetch. Each size will be tried
 *                              progressively until one is found.
 *
 * @return  {Number}            Height.
 */

export var getFeaturedImageNaturalHeight = function getFeaturedImageNaturalHeight(entity) {
  var sizes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var featuredImageObject = getFeaturedImageInfoWithFallback(entity, sizes);
  return _get(featuredImageObject, 'height');
};
/**
 * Get the featured image's natural width.
 *
 * @param   {Object} entity     WordPress entity.
 * @param   {Array} sizes       Size to fetch. Each size will be tried
 *                              progressively until one is found.
 *
 * @return  {Number}            Width.
 */

export var getFeaturedImageNaturalWidth = function getFeaturedImageNaturalWidth(entity) {
  var sizes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var featuredImageObject = getFeaturedImageInfoWithFallback(entity, sizes);
  return _get(featuredImageObject, 'width');
};
/**
 * Get a srcSet containing all the images at the same ratio of a given image size.
 *
 * @param   {Object} entity     WordPress entity.
 * @param   {Array} sizes       Size of the main image that sets the aspect ratio. If multiple
 *                              images are present, each size will be tried progressively until
 *                              one is found.
 *
 * @return  {String}            `srcSet` string.
 */

export var getFeaturedImageSrcSet = function getFeaturedImageSrcSet(entity) {
  var sizes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['primary-xxxl', 'primary-xxl', 'primary-xl', 'primary-l', 'primary-m', 'primary-s', 'primary-xs', 'primary-xxs'];
  var featuredImageObject = getFeaturedImageObject(entity);
  var sources = [];

  _flow([// get the size list
  _getOr([], 'media_details.sizes'), // filter by sizes arg
  _pick(sizes), // sort by image widths
  _sortBy(function (s) {
    return s.width;
  }), // add size to source list
  _each(function (currSize) {
    var srcUrl = _get(currSize, 'source_url');

    var width = _get(currSize, 'width');

    sources.push("".concat(srcUrl, " ").concat(width, "w"));
  })])(featuredImageObject);

  return sources.join(', ');
};
/**
 * Get associated house ad ID including category hierarchy fallback.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {number}            House ad ID.
 */

export var getHouseAdId = function getHouseAdId(entity) {
  if (getUseCustomHouseAd(entity)) {
    return _get(getNwData(entity), 'custom_house_ad.id');
  }

  return getHouseAdIdFromEntityCategory(entity);
};
/**
 * Get house ad ID for an entity's associated category hierarchy.
 *
 * @param   {Object} entity             WordPress entity.
 *
 * @return  {number|null}               House ad ID.
 */

var getHouseAdIdFromEntityCategory = _ary(makeGetEntityFromCategoryAncestor('nw_default_house_ad.id'), 1);
/**
 * Get entity ID.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            ID.
 */


export var getId = function getId(entity) {
  return _get(entity, 'id');
};
/**
 * Get entity keyword.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            Keyword.
 */

export var getKeyword = function getKeyword(entity) {
  return _get(entity, 'nw_seo.keyword') || _get(entity, 'nw_seo_keyword');
};
/**
 * Get entity link.
 *
 * @summary This is used primarily for strict URL comparison in
 *     clients (e.g. determining whether or not to redirect). See also
 *     {@link #module_selectors/common.getCanonicalUrl getCanonicalUrl} for
 *     use in SEO / metadata.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            Link.
 */

export var getLink = function getLink(entity) {
  return _get(entity, 'link');
};
/**
 * Get methodology block object.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string|Object}     HTML String or Structured Content Object for methodology.
 */

export var getMethodology = function getMethodology(entity) {
  return getBlockObjectById(entity, getBlockIdMethodology(entity));
};
/**
 * Get entity nofollow.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            Nofollow.
 */

export var getNofollow = function getNofollow(entity) {
  return _get(entity, 'nw_seo.nofollow') || _get(entity, 'nw_seo_nofollow');
};
/**
 * Get entity noindex.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            Noindex.
 */

export var getNoindex = function getNoindex(entity) {
  return _get(entity, 'nw_seo.noindex') || _get(entity, 'nw_seo_noindex');
};
/**
 * Get entity page taxonomy data.
 *
 * @param   {Object} entity     WordPress entity or query0 post object.
 *
 * @return  {Array}             Page taxonomy data.
 */

export var getPageTaxonomyData = function getPageTaxonomyData(entity) {
  if (entity.__typename) return entity.pageTaxonomy;
  return _get(entity, 'nw_gms_page_taxonomy', []);
};
getPageTaxonomyData.fragment = gql(_templateObject());
/**
 * Get entity page taxonomy data element.
 *
 * @param   {Object} entity     WordPress entity.
 * @param   {string} elem       Desired `nwVarName` key-value
 *
 * @return  {Object}            Page taxonomy data element.
 */

export var getPageTaxonomyDataElem = function getPageTaxonomyDataElem(entity, elem) {
  if (!elem) {
    return null;
  }

  var taxonomyData = getPageTaxonomyData(entity);
  return _find(taxonomyData, {
    nwVarName: elem
  });
};
/**
 * Get post-type-specific label.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            Post type label.
 */

export var getPostTypeLabel = function getPostTypeLabel(entity) {
  return POST_TYPE_LABELS[getType(entity)];
};
/**
 * Get entity slug.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            Page slug (e.g. `free-investments-can-come-at-a-cost`).
 */

export var getSlug = function getSlug(entity) {
  return _get(entity, 'slug');
};
/**
 * Get entity publish status.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            Post status (one of POST_STATUSES).
 */

export var getStatus = function getStatus(entity) {
  return _get(entity, 'status');
};
/**
 * Get entity synopsis.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            Synopsis.
 */

export var getSynopsis = function getSynopsis(entity) {
  var _callSelectorByType;

  return callSelectorByType(entity, (_callSelectorByType = {}, _defineProperty(_callSelectorByType, POST_TYPES.ARTICLE, articleSelectors.getSynopsis), _defineProperty(_callSelectorByType, POST_TYPES.ROUNDUP, roundupSelectors.getSynopsis), _defineProperty(_callSelectorByType, POST_TYPES.REVIEW, reviewSelectors.getSynopsis), _callSelectorByType));
};
/**
 * Get entity title.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            Title.
 */

export var getTitle = function getTitle(entity) {
  return callSelectorByType(entity, _defineProperty({}, POST_TYPES.ROUNDUP, roundupSelectors.getTitle), function () {
    var _entity$title$rendere, _entity$title;

    return (_entity$title$rendere = entity === null || entity === void 0 ? void 0 : (_entity$title = entity.title) === null || _entity$title === void 0 ? void 0 : _entity$title.rendered_text) !== null && _entity$title$rendere !== void 0 ? _entity$title$rendere : '';
  });
};
/**
 * Get entity seo title.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            SEO title.
 */

export var getTitleSeo = function getTitleSeo(entity) {
  return callSelectorByType(entity, _defineProperty({}, POST_TYPES.ROUNDUP, roundupSelectors.getTitleSeo), function () {
    var seoTitle = _get(entity, 'nw_seo.title') || getTitle(entity); // safety check

    return seoTitle && "".concat(stripNwSuffix(seoTitle), " - NerdWallet");
  });
};
/**
 * Get entity type.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {string}            Type (one of POST_TYPES).
 */

export var getType = function getType(entity) {
  return _get(entity, 'type');
};
/**
 * Get the url path for the entity, i.e. for a url like `www.nerdwallet.com/article/banking/best-banks`,
 * returns `/article/banking/best-banks`.
 *
 * @param {Object}               WordPress entity.
 *
 * @return {string}              The pathname for the entity
 */

export var getUrlPath = function getUrlPath(entity) {
  var _urlParse;

  return entity.link ? (_urlParse = urlParse(getLink(entity))) === null || _urlParse === void 0 ? void 0 : _urlParse.pathname : '';
};
/**
 * Get flag indicating whether or not to use a custom below content block group.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {boolean}           Whether or not to use a custom below content block group.
 */

export var getUseCustomBlockGroupBelowContent = function getUseCustomBlockGroupBelowContent(entity) {
  return _get(getNwData(entity), 'use_custom_below_content');
};
/**
 * Get flag indicating whether or not to use a custom sidebar block group.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {boolean}           Whether or not to use a custom sidebar.
 */

export var getUseCustomBlockGroupSidebar = function getUseCustomBlockGroupSidebar(entity) {
  return _get(getNwData(entity), 'use_custom_sidebar');
};
/**
 * Get flag indicating whether or not to use a custom house ad.
 *
 * @param   {Object} entity     WordPress entity.
 *
 * @return  {boolean}           Whether or not to use a custom house ad.
 */

export var getUseCustomHouseAd = function getUseCustomHouseAd(entity) {
  return _get(getNwData(entity), 'use_custom_house_ad');
};
/**
 * Get each FAQ instance.
 *
 * @param   {Object} entity    WordPress entity.
 * @return  {Array}            FAQ { question, answer } list.
 */

export var getFaqs = function getFaqs(entity) {
  return _get(getNwData(entity), 'faqs') || [];
};
/**
 *
 * Get boolean to show FAQ instance(s).
 *
 * @param   {Object} entity     WordPress entity.
 * @return  {Boolean}           true or false that FAQ instances can be shown.
 */

export var getShowFaq = function getShowFaq(entity) {
  return _get(getNwData(entity), 'show_faqs') === true;
};